export enum CollaboratorContractType {
  CDI = 'CDI',
  CDD = 'CDD',
}

export const getCollaboratorContractTypeLabel = (
  value: CollaboratorContractType
): string => {
  switch (value) {
    case CollaboratorContractType.CDI:
      return $localize`CDI`;
    case CollaboratorContractType.CDD:
      return $localize`CDD`;
    default:
      return value;
  }
};
